import { useMutation } from '@apollo/client'
import { FinishTestSession, FinishTestSessionVariables } from '../../types'
import { FINISH_TEST_SESSION } from './operations'

export const useFinishTestSession = () =>
  useMutation<FinishTestSession, FinishTestSessionVariables>(FINISH_TEST_SESSION)
